




import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class Img extends Vue {
  @Prop()
  private url!: string
  @Prop()
  private handleMeasure!: (w: number, height: number) => void

  private mounted() {
    const self = this
    const img = new Image()

    img.onload = function() {
      const that = this as any
      self.handleMeasure(that.width, that.height)
    }

    img.src = this.url
  }
}
